module.exports = __webpack_public_path__ + "img/PN.1fe31273.png";